module.exports = __webpack_public_path__ + "img/vipps.4bafd2e3.svg";